var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2292 15.5833H1.77083C0.79475 15.5833 0 14.7886 0 13.8125V1.77083C0 0.79475 0.79475 0 1.77083 0H15.2292C16.2052 0 17 0.79475 17 1.77083V13.8125C17 14.7886 16.2052 15.5833 15.2292 15.5833ZM1.77083 0.708333C1.18504 0.708333 0.708333 1.18504 0.708333 1.77083V13.8125C0.708333 14.3983 1.18504 14.875 1.77083 14.875H15.2292C15.815 14.875 16.2917 14.3983 16.2917 13.8125V1.77083C16.2917 1.18504 15.815 0.708333 15.2292 0.708333H1.77083Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6458 4.95833H0.354167C0.158667 4.95833 0 4.79967 0 4.60417C0 4.40867 0.158667 4.25 0.354167 4.25H16.6458C16.8413 4.25 17 4.40867 17 4.60417C17 4.79967 16.8413 4.95833 16.6458 4.95833Z",
    fill: "#D8D8D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6458 8.5013H0.354167C0.158667 8.5013 0 8.34264 0 8.14714C0 7.95164 0.158667 7.79297 0.354167 7.79297H16.6458C16.8413 7.79297 17 7.95164 17 8.14714C17 8.34264 16.8413 8.5013 16.6458 8.5013Z",
    fill: "#D8D8D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6458 12.0443H0.354167C0.158667 12.0443 0 11.8856 0 11.6901C0 11.4946 0.158667 11.3359 0.354167 11.3359H16.6458C16.8413 11.3359 17 11.4946 17 11.6901C17 11.8856 16.8413 12.0443 16.6458 12.0443Z",
    fill: "#D8D8D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60417 15.5833C4.40867 15.5833 4.25 15.4247 4.25 15.2292V4.60417C4.25 4.40867 4.40867 4.25 4.60417 4.25C4.79967 4.25 4.95833 4.40867 4.95833 4.60417V15.2292C4.95833 15.4247 4.79967 15.5833 4.60417 15.5833Z",
    fill: "#D8D8D8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50065 15.5833C8.30515 15.5833 8.14648 15.4247 8.14648 15.2292V4.60417C8.14648 4.40867 8.30515 4.25 8.50065 4.25C8.69615 4.25 8.85482 4.40867 8.85482 4.60417V15.2292C8.85482 15.4247 8.69615 15.5833 8.50065 15.5833Z",
    fill: "#D8D8D8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3952 15.5833C12.1997 15.5833 12.041 15.4247 12.041 15.2292V4.60417C12.041 4.40867 12.1997 4.25 12.3952 4.25C12.5907 4.25 12.7493 4.40867 12.7493 4.60417V15.2292C12.7493 15.4247 12.5907 15.5833 12.3952 15.5833Z",
    fill: "#D8D8D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableView);
export default __webpack_public_path__ + "static/media/table-view.31d945906834c8cf398ed3e843696aac.svg";
export { ForwardRef as ReactComponent };